import { render } from "./LinkAccountPage.vue?vue&type=template&id=75cdfb4f&scoped=true"
import script from "./LinkAccountPage.vue?vue&type=script&lang=js"
export * from "./LinkAccountPage.vue?vue&type=script&lang=js"

import "./LinkAccountPage.vue?vue&type=style&index=0&id=75cdfb4f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cdfb4f"]])

export default __exports__